"use client";
import React, { useState } from "react";
import {
  getFromLocalStorage,
  saveToLocalStorage,
} from "@/utils/localStorageUtils";
import { RunningTabsWelcomeModal } from "@/components/scanToOrder/runningTabsWelcomeModal/runningTabsWelcomeModal";
import { RunningTabsInvalidTableModal } from "./runningTabsInvalidTableModal";
import { LocalStorageKey } from "@/utils/storageKeys";
import { TableData, TableError } from "@/dto/tableData";
import { Merchant } from "@/dto/merchant";

interface WelcomeModalDisplayProps {
  merchant: Merchant;
  tableData: TableData | TableError;
}

export const WelcomeModalDisplay = ({
  merchant,
  tableData,
}: WelcomeModalDisplayProps) => {
  const isPopupTouched = getFromLocalStorage<boolean>(
    LocalStorageKey.SCANTOORDER_WELCOME_MODAL_TOUCED,
    false
  );
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const [isTouched, setIsTouched] = useState(!!isPopupTouched);
  const isTableError = "message" in tableData || tableData?.isValid === false;
  const isValidTable = tableData && !isTableError;

  const handleCloseModal = () => {
    const existingFlag = Boolean(isPopupTouched);
    saveToLocalStorage(
      LocalStorageKey.SCANTOORDER_WELCOME_MODAL_TOUCED,
      !existingFlag
    );
    setIsTouched(!existingFlag);
    setIsModalOpen(false);
  };

  if (isTouched) return null;

  return (
    <>
      {isValidTable && merchant?.isRunningTabsEnabled && (
        <RunningTabsWelcomeModal
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
          merchant={merchant}
        />
      )}
      {!isValidTable && (
        <RunningTabsInvalidTableModal
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
          merchant={merchant}
        />
      )}
    </>
  );
};
